import WeightList from './WeightList';
import TimeBar from './TimeBar';
import Chart from './Chart';
import Settings from './Settings';
import AddWeightButton from './AddWeightButton';

import React from 'react';

const ContentContainer = ({ onTimeClick, onWeightUnitClick, activeTimeId, weightsData, activeNavButton, activeWeightUnit, onAddNewWeight, onEditWeight, onDelete }) => {
  const buttonIds = ['chart', 'weights', 'settings'];

  const renderContent = () =>{
    switch(activeNavButton) {
      case buttonIds[0]:
        // Chart
        return(
          <React.Fragment>
            <TimeBar onClick={onTimeClick} activeTimeId={activeTimeId}/>
            <Chart weightsData={weightsData} weightUnit={activeWeightUnit} activeTimeId={activeTimeId}/>
            <hr className='addWeightButtonHr'/>
            <AddWeightButton onAddNewWeight={onAddNewWeight} weightUnit={activeWeightUnit}/>
          </React.Fragment>
        )
      case buttonIds[1]:
        // Weight List
        return(
          <React.Fragment>
            <TimeBar onClick={onTimeClick} activeTimeId={activeTimeId}/>
            <WeightList weightList={weightsData} onDelete={onDelete} weightUnit={activeWeightUnit} onEditWeight={onEditWeight}/>
            <hr className='addWeightButtonHr'/>
            <AddWeightButton onAddNewWeight={onAddNewWeight} weightUnit={activeWeightUnit}/>
          </React.Fragment>
        )
      case buttonIds[2]:
        // Settings
        return(
          <React.Fragment>
            <Settings onWeightUnitClick={onWeightUnitClick} activeWeightUnit={activeWeightUnit}/>
          </React.Fragment>
        )
    }
  }

  return (
    <div className='contentContainer'>
      {renderContent()}
      <a className='backLink' href="https://nickipedia.dev/" target="_blank" rel="noopener noreferrer">
        [ N ]
      </a>
    </div>
  )
}

export default ContentContainer